<template>
  <div v-if="cert_data != null">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <center>
      <v-btn class="button no-display" @click="print"> Print </v-btn>
      <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
    </center>
    <!-- Code for both SJCV and SJCK -->
    <template>
      <div v-if="show == true" id="document1">
        <div class="printdiv">
          <v-row justify="center" dense>
            <v-col
              cols="2"
              sm="2"
              md="2"
              align="center"
              style="padding-top: 20px"
            >
              <img
                v-if="org_basic_data.school_logo"
                :src="org_basic_data.school_logo"
                width="135px"
                height="90px"
                style="margin-left: -10px; margin-bottom: -10px"
                alt="logo"
              />
            </v-col>
            <v-col cols="12" sm="10" md="10" class="pb-0">
              <strong
                ><span
                  style="padding-left: 26%"
                  v-if="org_basic_data.trust_name"
                  >{{ org_basic_data.trust_name }}</span
                ></strong
              >

              <strong>
                <h1 style="text-align: center">
                  {{ org_basic_data.school_name }}
                </h1>
              </strong>
              <strong
                ><span
                  class="header"
                  style="text-align: center"
                  v-if="org_basic_data.address"
                  >{{ org_basic_data.address }} - {{ org_basic_data.pin }}</span
                ></strong
              >
              <v-row v-if="org_id == '6'" dense>
                <v-col cols="5" class="pb-0">
                  <span class="text-css"
                    >Phone No.: {{ org_basic_data.phone }}</span
                  >
                </v-col>
                <v-col cols="6" class="pb-0">
                  <span class="text-css pl-5"
                    >Email : {{ org_basic_data.email }}
                  </span>
                </v-col>
              </v-row>
            </v-col>             
          </v-row>
        <center><b>website : {{ org_basic_data.website }}</b></center>
         
          <hr style="border: solid 1px" />
          <v-row justify="center" class="ml-2">
            <v-col cols="12" sm="4" md="4">
              <strong v-if="org_id == '5'"
                >No.SJCV/{{ cert_data.cert_no }}</strong
              >
              <strong v-else>Ref.No.SJC/{{ cert_data.cert_no }}</strong
              ><br />
            </v-col>
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col align="right" cols="12" sm="3" md="3">
              <strong>
                <span style="margin-right: 15%"
                  >Date : {{ cert_data.cert_date }}
                </span>
              </strong>
            </v-col>
          </v-row>
          <center>
            <strong>
              <span class="certificate-text">Bonafide Certificate</span>
            </strong>
          </center>
          <br />
          <v-row class="main-row">
            <v-col cols="12" sm="12" md="12" style="font-size: 1.3em">
              <!-- This is to verify that Mast/Miss <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.stud_name }}</span></strong> -->
              <span>This to Certify that, Mr./Miss </span>
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 62%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.stud_name }}</span
                ></strong
              >
              <br />
              <br />
              <span>
                is/was a bonafide student of this Institute studying in Class :
                <strong
                  ><span
                    style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 17%;
                      display: inline-block;
                      line-height: 1;
                    "
                    >{{ cert_data.std }}</span
                  ></strong
                >
              </span>
              <br />
              <br />
              Div.<strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 6%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.div }}</span
                ></strong
              >
              Roll No.<strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 6%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ rollno }}</span
                ></strong
              >
              during the academic year
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 12%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.ay }}</span
                >.</strong
              >
              <br />
              <br />
              He/She bears a good moral character. <br />
              <br />
              Date of birth:
              <strong
                ><span>{{ cert_data.dob }}</span
                >.</strong
              >
              <br />
              <br />
              G.R.No.:
              <strong
                ><span>{{ cert_data.gr_no }}</span></strong
              >
              <br />
              <br />
              Place:
              <strong v-if="org_id == '5'"><span>Vaijapur</span></strong>
              <strong v-else><span>Kopargaon</span></strong>
              <br />
              <br />
            </v-col>
          </v-row>

          <div style="font-size: 1.3em; float: left; padding-left: 16px">
            Date :
            <strong>{{ cert_data.cert_date }}</strong>
          </div>
          <div
            style="
              font-size: 1.3em;
              float: right;
              padding-right: 2px;
              margin-right: 58px;
            "
          >
            <strong>PRINCIPAL</strong>
          </div>
          <br />
          <br />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      snackbar: false,
      fetch_loader: false,
      gen_cert_loader: false,
      show_cert_loader: false,
      search: "",
      rollno: "",
      dialog: false,
      awspath: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      data_list: [],
      ay_std_div_list: null,
      sel_ay_data: null,
      cert_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      overlay: false,
      show: true,
      org_id: null,
      org_basic_data: [],
      htmlToPdfOptions: {
        margin: 0,

        filename: `hehehe.pdf`,

        image: {
          type: "jpeg",
          quality: 0.98,
        },

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: true,
        },

        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "landscape",
        },
      },
      progress: 0,
    };
  },
  watch: {
    progress(val) {
      this.$emit("progress", val);
    },
  },
  methods: {
     print() {
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
    close() {
      this.$router.push({ name: "certificate-bonafied", target: "blank" });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      this.cert_data = JSON.parse(this.$route.query.cert_data || '{}');
      this.org_basic_data = JSON.parse(this.$route.query.org_basic_data || '{}');
      this.rollno = this.$route.query.rollno || "";
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.org_id = localStorage.getItem("EPS-org-id");
    this.onload();
  },
};
</script>
<style scoped>
.certificate-text {
  /* display: inline-block; */
  padding: 5px 50px;
  background-color: black;
  border-radius: 20px;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.2em;
}
.text-css {
  float: left;
  font-weight: bolder;
  text-align: center;
}
.main-row {
  margin-left: 2px;
  margin-right: 2px;
  line-height: 150%;
}
.printdiv {
   padding: 10px;
  width: 1000px;
  background-color: white;
  margin: auto;
}

@media print {
  .printdiv {
    width: 1450px;
    /* height: 1450px; */
    padding-left: 100px;
    margin-left: -16px !important;
    /* margin-top: -105px !important; */
    margin-right: -50px !important;
    font-size: 1.7em !important;
  }

  h1 {
    font-size: 55px !important;
    margin-bottom: 10px;
  }

  .certificate-text {
    font-size: 40px !important;
  }
  .header {
    line-height: 170% !important;
    font-size: 28px !important;
    margin-top: 10px;
    text-align: center;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  img {
    width: 200px !important;
    height: 170px !important;
    margin-top: 50px;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  @page {
    /* size: 25.5in 19in; */
    size: 13.5in 13.5in !important;
  }
  * {
    overflow: hidden !important;
  }
}
</style>